export const INBOX_LIST_THREAD_LAYOUT_STORAGE_KEY = "qwibInboxListThreadLayout";

export const INBOX_LIST_THREAD_LAYOUT = {
  sideBySide: "side-by-side",
  stacked: "stacked",
} as const;

export type InboxListThreadLayout = (typeof INBOX_LIST_THREAD_LAYOUT)[keyof typeof INBOX_LIST_THREAD_LAYOUT];

export const isInboxListThreadLayout = (value: string): value is InboxListThreadLayout =>
  value === INBOX_LIST_THREAD_LAYOUT.sideBySide || value === INBOX_LIST_THREAD_LAYOUT.stacked;
